import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import RadioCircle from '../radio-circle';
import './radio.css';

export default function Radio(props) {
  const {
    isDisabled = false,
    isInvalid = false,
    value = '',
    name = '',
    list = [],
    orientation = 'row',
    onFocus = () => {},
    onBlur = () => {},
    onChange,
  } = props;
  const { t } = useTranslation();
  const [hoveredItem, setHoveredItem] = useState('');
  const [focusedItem, setFocusedItem] = useState('');

  function radio() {
    return clsx('radio', {
      ['radio--row']: orientation === 'row' && hasNoInfo(list),
      ['radio--column']: orientation === 'column' || hasSomeInfo(list),
    });
  }
  function hasSomeInfo(list) {
    return list.some((l) => !!l.info);
  }
  function hasNoInfo(list) {
    return list.every((l) => !l.info);
  }
  return (
    <div id='radio' className={radio()}>
      {list.map((item) => {
        const isChecked = item.value === value || ((item.isDefault || false) && item.value === value);
        const isHovered = item.value === hoveredItem;
        const isFocused = item.value === focusedItem;

        const onLabelClick = (e) => {
          if (e.pageX && e.pageY && !isDisabled) {
            e.preventDefault();
            onChange(name, item.value, 'click');
          }
        };

        const onLabelFocus = (e) => {
          setFocusedItem(item.value);
          onFocus(e);
        };

        const onLabelBlur = (e) => {
          setFocusedItem('');
          onBlur(e);
        };

        return (
          <div key={item.value}>
            <label
              className={clsx('radio__item', { ['radio__item--disabled']: isDisabled })}
              onClick={onLabelClick}
              onMouseEnter={() => setHoveredItem(item.value)}
              onMouseLeave={() => setHoveredItem('')}
              onFocus={onLabelFocus}
              onBlur={onLabelBlur}
            >
              <div className='radio__content'>
                <input
                  type='radio'
                  name={name}
                  id={item.value}
                  value={item.value}
                  disabled={isDisabled}
                  checked={isChecked}
                  className='radio__input'
                  onChange={() => {
                    onChange(name, item.value, 'focus');
                  }}
                />
                <RadioCircle
                  isChecked={isChecked}
                  isHovered={isHovered}
                  isFocused={isFocused}
                  isDisabled={isDisabled}
                  isInvalid={isInvalid}
                  size='small'
                />
                <span className='radio__label'>{t(item.label)}</span>
              </div>
              {item.info && <div className='radio__info' dangerouslySetInnerHTML={{ __html: t(item.info) }} />}
            </label>
          </div>
        );
      })}
    </div>
  );
}

Radio.displayName = 'Radio';

Radio.propTypes = {
  isDisabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  value: PropTypes.string,
  name: PropTypes.string,
  orientation: PropTypes.oneOf(['row', 'column']),
  list: PropTypes.array,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};
